module.exports = __webpack_public_path__ + "static/zen-6d26f99fa04063c34789f5699ea2b7d0.png";